module.exports = __webpack_public_path__ + "static/media/font_medium.4c5e67b0.woff2";